import { Accordion } from '@everlywell/leaves';
import SectionWrapper from 'components/SectionWrapper';
import React from 'react';
import { generateKey } from 'utils/helpers';

import * as S from './styles';

type TAccordion = {
  title: string;
  description: string;
};

export interface IFAQ {
  heading: string;
  listOfObjects: TAccordion[];
  backgroundColor: string;
  slug?: string;
}

const AccordionItem: React.FC<TAccordion> = ({ title, description }) => (
  <Accordion.Item>
    <S.AccordionHeading>{title}</S.AccordionHeading>
    <S.AccordionChild showBorderBottom={true}>{description}</S.AccordionChild>
  </Accordion.Item>
);

export const HeaderAccordionItem: React.FC<IFAQ> = ({
  heading,
  listOfObjects,
  backgroundColor,
  slug,
}) => (
  <SectionWrapper data-testid="faq" id={slug} backgroundColor={backgroundColor}>
    <S.Wrapper>
      <S.SectionHeadline>{heading}</S.SectionHeadline>
      <Accordion.Wrapper>
        <S.AccordionWrapper>
          {listOfObjects.map((item) => (
            <AccordionItem
              title={item.title}
              description={item.description}
              key={generateKey()}
            />
          ))}
        </S.AccordionWrapper>
      </Accordion.Wrapper>
    </S.Wrapper>
  </SectionWrapper>
);

export default HeaderAccordionItem;
